import { render } from "./ShowFilteredVimsottariDasas.vue?vue&type=template&id=16ff9b23&scoped=true"
import script from "./ShowFilteredVimsottariDasas.vue?vue&type=script&lang=js"
export * from "./ShowFilteredVimsottariDasas.vue?vue&type=script&lang=js"

import "./ShowFilteredVimsottariDasas.vue?vue&type=style&index=0&id=16ff9b23&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ff9b23"]])

export default __exports__